<template>

    <stats :show-headline="false" :show-grid="true" :grid-cols="5">
        <stat v-if="showQuantity"
              :name="$t('pages.analytics.details.controls.qty_plan')"
              :value="auction?.article_quantity"
              :same-width="true"/>
        <stat v-if="!showQuantity"
              :name="$t('pages.analytics.details.controls.auction_date')"
              :value="performanceDetails?.auction_date | formatDay"
              :same-width="true"/>
        <stat :name="$t('pages.analytics.details.controls.bids')"
              :value="performanceDetails?.bid_count"
              :same-width="true"/>
        <stat :name="$t('pages.analytics.details.controls.floor_sales_bid' + this.$page.props.tenant.labels_key)"
              :value="performanceDetails?.floorsales_bid | toCurrency"
              :same-width="true"/>
        <stat :name="$t('pages.analytics.details.controls.visitors')"
              :value="performanceDetails?.visitors"
              :same-width="true"/>
        <stat :name="$t('pages.analytics.details.controls.bids_per_visitor')"
              :value="parseInt(performanceDetails?.bids_per_visitor) + '%'"
              :same-width="true"/>


        <stat v-if="showQuantity"
              :name="$t('pages.analytics.details.controls.qty_available')"
              :value="performanceDetails?.quantity_available"
              :same-width="true"/>
        <stat v-if="!showQuantity"
              :name="$t('pages.analytics.details.controls.product_id')"
              :value="performanceDetails?.product_id"
              :same-width="true"/>
        <stat :name="$t('pages.analytics.details.controls.sales_percentage_of_bids')"
              :value="performanceDetails?.sales_count"
              :second-value="' (' + performanceDetails?.sales_percentage_of_bids?.toFixed(0) + '%)'"
              :same-width="true"/>
        <stat :name="$t('pages.analytics.details.controls.floor_sales_sold' + this.$page.props.tenant.labels_key)"
              :value="performanceDetails?.floorsales_sold | toCurrency"
              :same-width="true"/>
        <stat :name="$t('pages.analytics.details.controls.quantity_bid')"
              :value="performanceDetails?.quantity_per_bid.toFixed(2)"
              :same-width="true"/>
        <stat :name="$t('pages.analytics.details.controls.quantity_sold_vs_planned')"
              :value="performanceDetails?.quantity_sold + ' / ' + performanceDetails?.quantity_planned"
              :same-width="true"/>


        <stat :name="$t('pages.analytics.details.controls.levels')"
              :value="performanceDetails?.levels_actual + ' / ' + auction?.levels?.length"
              :same-width="true"/>
        <stat :name="$t('pages.analytics.details.controls.average_price')"
              :value="performanceDetails?.average_price_bids | toCurrency"
              :same-width="true"/>
        <stat :name="$t('pages.analytics.details.controls.shop_price' + this.$page.props.tenant.labels_key)"
              :value="performanceDetails?.shop_price | toCurrency"
              :same-width="true"/>
        <stat
            :name="$t( performanceDetails?.bid_count > 0 ? 'pages.analytics.details.controls.max_price_bid': 'pages.analytics.details.controls.max_price_plan')"
            :value="performanceDetails?.max_price | toCurrency"
            :same-width="true"/>
        <stat
            :name="$t( performanceDetails?.bid_count > 0 ? 'pages.analytics.details.controls.min_price_bid' : 'pages.analytics.details.controls.min_price_plan')"
            :value="performanceDetails?.min_price | toCurrency"
            :same-width="true"/>
    </stats>
</template>


<script>
import Layout from '@/Shared/Layout';
import Stats from "../Stats";
import Stat from "../Stat";

export default {
    layout: Layout,
    components: {
        Stats,
        Stat
    },
    props: {
        auction: {
            type: Object,
            default: null
        },
        performanceDetails: Object,
        showQuantity: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            printPreviewId: '',
            auctions: this.initialAuctions
        }
    },
    created() {
        this.generateId();
    },
    computed: {
        visitors() {
            return this.performanceDetails?.visitors || 0;
        },
        floorSales() {
            return this.auction.levels.reduce((acc, level) => {
                return acc + level.quantity_used * level.price;
            }, 0);
        },
        bidsPerVisitor() {
            if (this.auction.bids.length === 0) {
                return 0;
            }
            return this.performanceDetails?.visitors / this.auction.bids.length;
        },
        quantityActual() {
            return this.auction.article_quantity;
        },
        quantityPlan() {
            return this.auction.originLevels ? this.auction.originLevels.available_quantity : this.quantityActual;
        },
        averagePrice() {
            const soldQty = this.soldQuantity;
            if (0 === soldQty) {
                return 0;
            }
            return this.floorSales === 0 ? 0 : this.floorSales / soldQty;
        },
        executedLevels() {
            return this.auction.levels.reduce((accumulator, level) => {
                if (['passed'].indexOf(level.state) >= 0) {
                    return accumulator + 1;
                }
                return accumulator;
            }, 0);
        },
        levelsPlanned() {
            return this.auction.planned ? this.auction.planned.levels.length : this.auction.levels.length;
        },
        soldQuantity() {
            return this.auction.levels.reduce((accumulator, level) => {
                return accumulator + level.quantity_used;
            }, 0);
        }
    },
    methods: {
        generateId() {
            if (this.printPreviewId.length === 0) {
                this.printPreviewId = 'auction-performance-details-' + Math.floor(Math.random() * 100000000000).toString();
            }
        },
        showPrevOrNext(auctionId) {
            this.$emit('go-to-details', auctionId)
        },
        setAuctions(auctions) {
            this.auctions = auctions;
        }
    }
}
</script>
